import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {styled} from "@mui/material/styles";

import CustomTooltip from "./index";
import {ReactComponent as InfoCircle} from "assets/img/info-circle.svg";
import {greyishBlue400} from "assets/jss/main";

InfoTooltipIcon.propTypes = {
    titleId: PropTypes.string,
    title: PropTypes.node,
    multiline: PropTypes.bool,
    size: PropTypes.number,
    color: PropTypes.string,
    placement: PropTypes.string,
    onClick: PropTypes.func,
};

// styled() forwards the ref the tooltip needs to anchor itself
const Icon = styled(InfoCircle, {shouldForwardProp: (prop) => !['size', 'color', 'clickable'].includes(prop)})(({size, color, clickable}) => ({
    width: `${size}px`,
    height: `${size}px`,
    flexShrink: 0,
    cursor: clickable ? 'pointer' : undefined,
    'path': {
        stroke: color
    }
}));

const MultilineTitle = styled('span')({
    whiteSpace: 'pre-line'
});

function InfoTooltipIcon({titleId, title, multiline = false, size = 16, color = greyishBlue400, placement, onClick, ...tooltipProps}) {
    const content = titleId ? <FormattedMessage id={titleId}/> : title

    return (
        <CustomTooltip title={multiline ? <MultilineTitle>{content}</MultilineTitle> : content} placement={placement} {...tooltipProps}>
            <Icon size={size} color={color} clickable={!!onClick} onClick={onClick}/>
        </CustomTooltip>
    );
}

export default InfoTooltipIcon;
